import Toast from '../../component/toastify/Index.jsx';
import axios from '../../axios/interceptor.js';

export const getAllCustomerCompany = async (payload) => {
    try {
        const response = await axios.get('/customer/company/getCompanyList', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getCustomerCompanyDetails = async () => {
    try {
        const response = await axios.get('/customer/company/getCustomerCompanyDetail')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateCustomerCompanyDetail = async (payload) => {
    try {
        const response = await axios.put('/customer/company/updateCustomerCompany', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}